import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChecklistVote } from '../classes/checklistVote';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ChecklistVoteService {
    API_CHECKLIST_VOTE_URL = config.serverAddress + ':' + config.serverPort + '/checklist-vote/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CHECKLIST_VOTE_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_CHECKLIST_VOTE_URL + id);
    }
    getByIDInspection(idInspection: string | null) {
        return this.http.get(this.API_CHECKLIST_VOTE_URL + 'inspection/' + idInspection);
    }
    create(checklistVote: ChecklistVote) {
        return this.http.post(this.API_CHECKLIST_VOTE_URL + 'create', checklistVote);
    }
    update(checklistVote: ChecklistVote) {
        return this.http.put(this.API_CHECKLIST_VOTE_URL + 'update', checklistVote);
    }
    upsertMassive(checklistVotes: Array<any>) {
        return this.http.post(this.API_CHECKLIST_VOTE_URL + 'upsert', checklistVotes);
    }
    delete(id: number) {
        return this.http.delete(this.API_CHECKLIST_VOTE_URL + 'delete/' + id);
    }
    deleteByIDInspection(idInspection: number) {
        return this.http.delete(this.API_CHECKLIST_VOTE_URL + 'delete/inspection/' + idInspection);
    }
}
